import { Workbook } from "exceljs";

export async function readCsvFile(file: File, limit?: number): Promise<(any[])[] | null> {
  return (await file.text())
    .split(/(?:(\r\n)|(\n))+/)
    .filter(x => !!x && ((x !== "\n") && (x !== "\r\n")))
    .slice(0, limit)
    .map(row => row.split(","));
}

export async function readXlsxFile(file: File, limit?: number): Promise<(any[])[] | null> {
  const workbook = new Workbook();
  await workbook.xlsx.load(await file.arrayBuffer());
  const sheet = workbook.worksheets[0];

  const result: any[] = [];
  sheet.eachRow((row, rowIndex) => {
    if ((limit && rowIndex <= limit) || !limit) {
      result.push((row.values as any[]).slice(1)
        .map(x => x?.result ? x?.result : x));
    }
  });

  return result;
}

export const loadFile = async (file?: File | null, limit?: number) => {
  let data = null;

  if (file?.type === "text/csv") {
    data = await readCsvFile(file, limit);
  } else if (file?.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
    data = await readXlsxFile(file, limit);
  }

  return data;
};
